import { API_BASE_URL } from '../../../lib/api';

import { apiFetch } from '@/lib/apiFetch';
import { withTenant } from '../../../lib/tenantHeaders';

/**
 * Los headers se construyen DENTRO de cada función a propósito.
 * `withTenant()` lee el token y el slug de localStorage: si se calcula
 * una sola vez al importar el módulo (como hacen los services del
 * aéreo), quedan congelados y un re-login sin recargar la página deja
 * headers obsoletos.
 */
const jsonHeaders = () => withTenant({ 'Content-Type': 'application/json' });

export const fetchLclRequests = async ({ limit = 10, offset = 1, query = {}, sort } = {}) => {
  const res = await apiFetch(`${API_BASE_URL}/lcl-requests/filter`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify({ limit, offset, query, sort }),
  });
  return res.json();
};

export const getLclRequest = async (id) => {
  const res = await apiFetch(`${API_BASE_URL}/lcl-requests/${id}`, {
    headers: withTenant(),
  });
  return res.json();
};

export const createLclRequest = async (data) => {
  const res = await apiFetch(`${API_BASE_URL}/lcl-requests`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(data),
  });
  return res.json();
};

export const updateLclRequest = async (id, data) => {
  const res = await apiFetch(`${API_BASE_URL}/lcl-requests/${id}`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(data),
  });
  return res.json();
};

export const deleteLclRequest = async (id) => {
  const res = await apiFetch(`${API_BASE_URL}/lcl-requests/${id}`, {
    method: 'DELETE',
    headers: withTenant(),
  });
  return res.json();
};

/**
 * Cambia el estado de la solicitud (Borrador / Enviada / Aprobada / Rechazada).
 * Backend: POST /lcl-requests/:id/estado  body: { estado: 'Aprobada' }
 */
export const setEstado = async (id, estado) => {
  const res = await apiFetch(`${API_BASE_URL}/lcl-requests/${id}/estado`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify({ estado }),
  });
  return res.json();
};
